import * as icons from 'assets/icons'

import React, {HTMLProps} from 'react'

import {Variant} from 'util/styler'
import css from './icon.module.scss'
import {fromModule} from 'util/styler/Styler'

export type IconKey = keyof typeof icons

const styles = fromModule(css)

export const Icon: React.FC<
	{
		icon: IconKey
		inline?: boolean
		nofill?: boolean
		mod?: Variant<'maxwidth'>
	} & HTMLProps<HTMLDivElement>
> = ({icon, inline, nofill, mod, ...rest}) => {
	if (!icons[icon]) {
		console.warn(`Undefined icon key: ${icon}`)
		return null
	}

	const Component = icons[icon].default as any
	return (
		<span
			{...rest}
			data-icon={icon}
			className={styles.icon.mergeProps(rest).mod({inline, nofill}).mod(mod)()}
		>
			<Component />
		</span>
	)
}
